import appApi from '../../../../../../../api/app-api';
import { toast } from 'react-toastify';
import { AssignmentStudent } from '../../../../../../../api/types/assignment-student-details/response/assignment-student-db';

export const loadAssignmentDetailsOperations = async (
  programId: number | undefined,
  courseId: number | undefined,
  assignmentId: number,
  setStudentData: (studentData: AssignmentStudent[]) => void,
): Promise<AssignmentStudent[]> => {
  try {
    if (isNaN(Number(programId)) || isNaN(Number(courseId))) {
      console.error(
        `Can not find curretn programId: ${programId} and courseId: ${courseId}`,
      );
      toast.warn(
        'לא ניתן לאתר את מזהה התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים',
      );
      return;
    }
    // TODO load assignment data api
    const res = await appApi.getAssignmentData(
      programId,
      courseId,
      assignmentId,
    );

    const dataRes: AssignmentStudent[] = res.data.body;
    //setStudentData(dataRes);
    return dataRes;
  } catch (e) {}
};
